import React from 'react';
import { Crown } from 'lucide-react';
import CandidatoAvatar from '../../components/CandidatoAvatar';
import { capitalize } from './constants';

function MiniBar({ label, value, color }) {
  return (
    <div className="flex items-center gap-1">
      <span className="text-[8px] text-gray-500 w-8 shrink-0">{label}</span>
      <div className="flex-1 h-1 rounded-full bg-white/[.06] overflow-hidden">
        <div className={`h-full rounded-full ${color}`} style={{ width: `${value}%` }} />
      </div>
      <span className="text-[8px] font-bold text-gray-400 w-4 text-right">{Math.round(value)}</span>
    </div>
  );
}

export default function MayorBubble({ prefeito, selectedCity, children }) {
  const ind = prefeito?.indicadores;

  return (
    <div className="mayor-bubble">
      <div className="mayor-bubble__header">
        {prefeito ? (
          <CandidatoAvatar candidato={prefeito} foto={prefeito.foto} nome={prefeito.nome} size={44} className="rounded-lg border border-amber-500/20 shrink-0" />
        ) : (
          <div className="mayor-bubble__avatar-placeholder">
            <Crown size={20} className="mayor-bubble__avatar-placeholder-icon" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="mayor-bubble__name">{prefeito ? capitalize(prefeito.nome) : 'Prefeito(a)'}</p>
          <p className="mayor-bubble__role">
            {prefeito ? `${prefeito.partido} · Prefeito(a) de ${selectedCity?.name}` : `Prefeito(a) de ${selectedCity?.name}`}
          </p>
          {ind && (
            <div className="mt-1.5 space-y-0.5">
              <MiniBar label="Carisma" value={ind.carisma} color="bg-green-400" />
              <MiniBar label="Influência" value={ind.influencia} color="bg-purple-400" />
              <MiniBar label="Recursos" value={ind.recursos} color="bg-amber-400" />
              <MiniBar label="Risco" value={ind.risco} color="bg-red-400" />
            </div>
          )}
        </div>
      </div>
      <div className="mayor-bubble__content">
        {children}
      </div>
    </div>
  );
}
